<template>
  <div class="d-flex justify-content-center flex-wrap icons-container">
    <a
      v-for="(card, index) in cards"
      :key="index"
      :href="`#${card.title}`"
      class="icons text-center m-2"
      :class="[hoveredIndex === index ? card.hoverBg : card.bg]"
      @mouseover="hoveredIndex = index"
      @mouseleave="hoveredIndex = null"
      @focus="hoveredIndex = index"
      @blur="hoveredIndex = null"
    >
      <div>
        <b-img
          fluid
          :src="hoveredIndex === index ? card.hoverSrc : card.src"
          alt=""
        />
        <p
          class="m-0"
          :class="[hoveredIndex === index ? card.hoverColor : card.color]"
        >
          {{ card.title }}
        </p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "InfoAnchorLinks",
  data() {
    return {
      hoveredIndex: null,
      cards: [
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/venue.svg",
          hoverSrc:
            "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/venue-hover.svg",
          title: "venue",
          color: "dark-brown",
          hoverColor: "bright-yellow",
          bg: "bg-bright-yellow",
          hoverBg: "bg-dark-brown",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/wifi.svg",
          hoverSrc:
            "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/wifi-hover.svg",
          title: "wifi",
          color: "dark-brown",
          hoverColor: "light-pink",
          bg: "bg-light-pink",
          hoverBg: "bg-dark-brown",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/food.svg",
          hoverSrc:
            "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/food-hover.svg",
          title: "food",
          color: "dark-brown",
          hoverColor: "purple",
          bg: "bg-purple",
          hoverBg: "bg-dark-brown",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/luggage.svg",
          hoverSrc:
            "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/luggage-hover.svg",
          title: "luggage",
          color: "dark-brown",
          hoverColor: "orange",
          bg: "bg-orange",
          hoverBg: "bg-dark-brown",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/language.svg",
          hoverSrc:
            "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/language-hover.svg",
          title: "language",
          color: "dark-brown",
          hoverColor: "blue",
          bg: "bg-blue",
          hoverBg: "bg-dark-brown",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/travel.svg",
          hoverSrc:
            "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/travel-hover.svg",
          title: "travel",
          color: "dark-brown",
          hoverColor: "light-pink",
          bg: "bg-light-pink",
          hoverBg: "bg-dark-brown",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/parking.svg",
          hoverSrc:
            "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/parking-hover.svg",
          title: "parking",
          color: "dark-brown",
          hoverColor: "mint",
          bg: "bg-mint",
          hoverBg: "bg-dark-brown",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/price.svg",
          hoverSrc:
            "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/price-hover.svg",
          title: "prices",
          color: "dark-brown",
          hoverColor: "bright-yellow",
          bg: "bg-bright-yellow",
          hoverBg: "bg-dark-brown",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/hotel.svg",
          hoverSrc:
            "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/hotel-hover.svg",
          title: "hotel",
          color: "dark-brown",
          hoverColor: "lime-green",
          bg: "bg-lime-green",
          hoverBg: "bg-dark-brown",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1745335982/2025/Info/Icons/volunteer.svg",
          hoverSrc:
            "https://res.cloudinary.com/oredev/image/upload/v1742910187/2025/Info/Icons/volunteer-hover.svg",
          title: "volunteer",
          color: "dark-brown",
          hoverColor: "purple",
          bg: "bg-purple",
          hoverBg: "bg-dark-brown",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

.icons-container {
  max-width: 340px;
  @media only screen and (min-width: 577px) {
    max-width: 464px;
  }
  @media only screen and (min-width: 768px) {
    max-width: 580px;
  }
  @media only screen and (min-width: 992px) {
    max-width: 780px;
  }
  .icons {
    display: flex;
    justify-content: center; // vertical centering
    align-items: center; // horizontal centering
    border-radius: 15px;
    border: 3px solid $dark-brown;
    text-transform: uppercase;
    text-decoration: none !important;
    height: 100px;
    width: 100px;
    color: $dark-brown;
    img {
      width: 32px;
    }
    p {
      font-size: 12px;
      font-weight: 600;
    }
    @media (min-width: 992px) {
      width: 140px;
      height: 140px;
      img {
        width: 56px;
      }
      p {
        font-size: 16px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/InfoAnchorLinks.vue